// extracted by mini-css-extract-plugin
module.exports = {"dh-psy-reveal":"dh-psy-reveal","dh-psy-reveal--centered":"dh-psy-reveal--centered","dh-psy-reveal__bg":"dh-psy-reveal__bg","dh-psy-reveal__default-bg":"dh-psy-reveal__default-bg"};